export default {
  allSharedServicePassengers: [],
}
